<template src="../templates/normal_fcont_34.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import PrintButton from '../components/PrintButton'
import UseDesignPaperList from '../components/UseDesignPaperList'
import CreatorProfileMaikaKokubo from '../components/CreatorProfileMaikaKokubo'
import { Carousel,Slide } from 'uiv'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
export default {
  name: 'app',
  components: {
   LabelFunMessage,FuncSearchRecommendLink,Carousel,Slide,FuncSearchGalleryQR,
   PrintButton,UseDesignPaperList,CreatorProfileMaikaKokubo
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['34-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['34-2']}
    ]};
  }
};
</script>
<style />


